<template>
  <div>
    <base-button block type="primary" class="m-0" @click="modal = true">
      {{ $t('fareGroups.create.btnLabel') }}
    </base-button>

    <modal :show.sync="modal"
           showClose
           modal-classes="modal-dialog-centered modal-lg"
           @close="resetForm()">
      <template slot="header">
        <h4 class="modal-title">
          {{ $t('fareGroups.create.titleText') }}
        </h4>
      </template>
      <template>
        <div class="text-center text-muted mb-4">
          <small>{{ $t('fareGroups.create.helpText') }}</small>
        </div>
        <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
          <!-- TODO: add error translation -->
          {{ getActionErrorDetails }}
        </base-alert>
        <form role="form" @submit.prevent="validate()">
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('fareGroups.form.id') }}</label>
            <div class="col-md-9">
              <base-input
                data-vv-as="'identifier'"
                name="id"
                v-validate="modelValidations.required"
                :error="getError('id')"
                v-model="formDetails.id">
              </base-input>
            </div>
          </div>

          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('fareGroups.form.description') }}</label>
            <div class="col-md-9">
              <base-input :error="getError('description')">
                <textarea class="form-control"
                          name="description"
                          data-vv-as="'description'"
                          v-validate="modelValidations.required"
                          v-model="formDetails.description"
                          rows="2"/>
              </base-input>
            </div>
          </div>

          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('fareGroups.form.free_pt_change_duration') }}</label>
            <div class="col-md-9">
              <base-input
                data-vv-as="'free_pt_change_duration'"
                name="freePtChangeDuration"
                v-validate="modelValidations.required"
                :error="getError('freePtChangeDuration')"
                v-model="formDetails.freePtChangeDuration">
              </base-input>
            </div>
          </div>

          <div class="text-center">
            <base-button
              type="primary"
              :loading="updating"
              class="my-4"
              native-type="submit"
            >{{ $t('fareGroups.create.actionBtnLabel') }}
            </base-button>
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>


<script>
  import {BaseAlert, Modal} from 'src/components';
  import {Option, Select} from 'element-ui';
  import {mapActions, mapState} from "vuex";

  export default {
    name: 'new-fare-group-btn',
    components: {
      [Option.name]: Option,
      [Select.name]: Select,
      Modal,
      BaseAlert
    },
    data() {
      return {
        modal: false,
        alert: false,
        loading: false,
        formDetails: {
          id: '',
          description: '',
          freePtChangeDuration: '30m0s'
        },
        modelValidations: {
          required: {
            required: true
          },
        }
      }
    },

    computed: {
      ...mapState({
        updating: state => state.fare_groups.updating,
        error: state => state.fare_groups.error,
      }),
      getActionErrorDetails() {
        return this.error ? this.error.bodyText : null;
      }
    },
    methods: {
      ...mapActions(['CreateFareGroup']),
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate: function () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.create()
          }
        });
      },
      create: function () {
        let payload = {
          id: this.formDetails.id,
          description: this.formDetails.description,
          details: {
            free_pt_change_duration: this.formDetails.freePtChangeDuration
          }
        }

        this.CreateFareGroup(payload).then(() => {
          if (this.$store.state.fare_groups.error != null) {
            this.alert = true
            // got error, don't reset form
          } else {
            this.resetForm();
            this.$router.push({name: 'fare-group', params: {id: payload.id}});
          }
        });
      },
      resetForm: function () {
        // closing dialog
        this.modal = false;

        // resetting alerts
        this.alert = false;

        // resetting form
        this.formDetails = {
          id: '',
          description: ''
        };

        // reset validation errors
        this.$validator.reset()
      }
    }
  }
</script>
